export enum FeatureFlag {
  RSS = 'resto365-rss',
  EON_REPORTING = 'resto365-eon-reporting',
  MASTER_PRODUCT_LIST = 'resto-master-product-list',
  FRANCHISE_HUB = 'resto365-franchisee',
  ORDER_MANAGEMENT = 'order-management',
  RECIPE_MANAGEMENT = 'resto-recipe-mgmt',
  CATERING_TIME_SLOTS = 'resto365-catering-time-slots',
  ADMIN_TOOLS = 'resto365-admin-tools',
  NRO_INSIGHT = 'resto365-nro-insight'
}
